import { Injectable } from '@angular/core';
import { FormField } from '../models/ropa.interface';

@Injectable({
  providedIn: 'root',
})
export class RopaUtilsService {
  /**
   * Checks if a field has selection limitations (max 25 selections)
   */
  isLimitedSelectionField(field: FormField): boolean {
    return (
      field.label === 'Owning Organization (Data Controller)' ||
      field.label ===
        'Select any and all of the AZ legal entity(ies) with whom the personal data is shared.'
    );
  }

  /**
   * Checks if description contains HTML
   */
  isHtmlDescription(description: string | undefined): boolean {
    if (!description) return false;
    const trimmed = description.trim();
    return trimmed.startsWith('<div') || trimmed.includes('<div');
  }

  /**
   * Formats file size in human readable format
   */
  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  /**
   * Validates file type and size
   */
  validateFile(file: File): boolean {
    const maxSize = 10 * 1024 * 1024; // 10MB
    const allowedTypes = [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'image/jpeg',
      'image/png',
    ];

    if (file.size > maxSize) {
      alert(`File "${file.name}" is too large. Maximum size is 10MB.`);
      return false;
    }

    if (!allowedTypes.includes(file.type)) {
      alert(`File "${file.name}" has an unsupported format.`);
      return false;
    }

    return true;
  }

  /**
   * Extracts PRID from user session
   */
  extractPridFromSession(session: any): string {
    if (session?.tokens) {
      const pridToken = session.tokens.accessToken.payload.username;
      const email = pridToken.split('@')[0];
      return email.split('_')[1];
    }
    return '';
  }
}
